import { BRACKET_STANDING_ACTION } from "core/constants/Actions";
import { Action } from "core/models/ActionTypes";
import { Standing } from "core/models/Bracket";

const initialState: {
  standings: Standing[] | null;
  isLoading: boolean;
} = {
  standings: null,
  isLoading: false,
};

interface ActionType extends Action {
  payload: {
    standings: Standing[];
  };
}

export default function bracketStandingReducer(
  state = initialState,
  action: ActionType
) {
  switch (action.type) {
    case BRACKET_STANDING_ACTION.REQUEST:
      return { ...state, isLoading: true };

    case BRACKET_STANDING_ACTION.SUCCESS:
      const { standings } = action.payload;
      return { ...state, standings, isLoading: false };

    case BRACKET_STANDING_ACTION.FAILURE:
      return { ...state, ...initialState };

    default:
      return state;
  }
}
